export default __webpack_public_path__ + "static/media/Venturer's Legguards of the Elder Bond.2c1545ac.jpg";